module.exports = "query GetReceivedPendingMembershipInvites {\n  receivedPendingMembershipInvites {\n    ...MembershipInviteFragment\n  }\n}\n"